import React from "react";
import { Button } from "react-bootstrap";

export default function IconButton({ children, ...buttonProps }) {
  return (
    <Button size="sm" {...buttonProps} className="icon-btn" variant="link">
      {children}
    </Button>
  );
}
